import React from 'react';
import { Trans } from '@lingui/react/macro';
import PermissionModeIcon from '@/components/permissions/PermissionModeIcon';
import { LocalizedEnum, ProjectFeeSet, ProjectMemberDetails } from '@/types';
import theme from './ProjectMemberPermissionsList.module.scss';
import PermissionsMatrixView from './PermissionsMatrixView';
import { useLingui } from '@lingui/react';

type ProjectUserPermissionsProps = {
    member: ProjectMemberDetails;
    permissions: LocalizedEnum[] | null;
    projectFeeSets: ProjectFeeSet[];
};

const UserPermissionsView: React.FC<ProjectUserPermissionsProps> = ({ member, permissions, projectFeeSets }) => {
    const { _ } = useLingui();

    return (
        <div>
            <div>
                <h4>
                    <Trans>User type</Trans>: &nbsp;
                    {member.isAdministrator ? <Trans>Administrator</Trans> : <Trans>Member</Trans>}
                </h4>
            </div>
            {!member.isAdministrator && (
                <>
                    <hr />
                    <div className={theme.row}>
                        <div className={theme.half}>
                            <h4>
                                <Trans>General permissions</Trans>
                            </h4>
                            <ul className="list-unstyled">
                                {member.projectPermissions.map((permission) => (
                                    <li key={permission}>
                                        <PermissionModeIcon value="Allow" />
                                        &nbsp;
                                        {_({ id: `ProjectPermissionType.${permission}` })}
                                    </li>
                                ))}
                                {member.projectPermissions.length === 0 && (
                                    <li className="text-missing">
                                        <Trans>None</Trans>
                                    </li>
                                )}
                            </ul>
                        </div>
                        <div className={theme.half}>
                            <h4>
                                <Trans>Allowed fees</Trans>
                            </h4>
                            <ul className="list-unstyled">
                                {projectFeeSets
                                    .filter((pfs) => member.allowedProjectFeeSetIds.includes(pfs.id))
                                    .map((pfs) => (
                                        <li key={pfs.id}>
                                            <PermissionModeIcon value="Allow" />
                                            &nbsp;
                                            {pfs.name}
                                        </li>
                                    ))}
                                {projectFeeSets.filter((pfs) => member.allowedProjectFeeSetIds.includes(pfs.id)).length ===
                                    0 && (
                                    <li className="text-missing">
                                        <Trans>None</Trans>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                    <hr />
                    <PermissionsMatrixView member={member} permissions={permissions} />
                </>
            )}
        </div>
    );
};

export default UserPermissionsView;
